import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  const n = t.notfound;
  return (
    <section data-testid="not-found" className="min-h-[80vh] flex items-center bg-white">
      <div className="container-x py-32 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <div className="overline">{n.label}</div>
          <h1 className="mt-6 display-xxl text-5xl sm:text-7xl text-primary">
            {n.title_l1}
            <br />
            {n.title_l2_a} <span className="text-accent">{n.title_l2_b}</span>
          </h1>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center gap-3 bg-primary text-white px-6 py-4 text-sm tracking-wide hover:bg-accent transition-colors"
          >
            {n.cta} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
